import {
  CampaignEventType,
  CreateVirtualSKUNode,
  ItemBonusOfferActionNode,
  ItemDiscountOfferActionNode,
  ItemOfferActionNode,
} from '@/api/dashboard'
import { Badge } from '@/ui'
import { useTranslation } from 'react-i18next'
import { useGameItemsQuery } from '@/api/useGameItems'
import { useGenerateCompanyPath } from '@/libs'
import { useContext } from 'react'
import { getContextItemText } from '@/layouts/campaigns/editors/common'
import { CampaignContext, ICampaignContext } from '@/expr/Context'

export const DescVirtualSKUActionNode = ({
  node,
}: {
  node: ItemOfferActionNode | CreateVirtualSKUNode | ItemBonusOfferActionNode | ItemDiscountOfferActionNode
}) => {
  const { t } = useTranslation()
  const context = useContext(CampaignContext) as ICampaignContext
  const { companyId, gameId } = useGenerateCompanyPath()
  const { data: items = [] } = useGameItemsQuery(companyId, gameId, {
    ids: node.item_id,
  })
  let benefits = ''

  if (node.bonus_percent) {
    benefits = `${node.bonus_percent}% ${t('campaign.virtual-sku-editor.bonus')}`
  }

  if (!benefits && node.discount_percent) {
    benefits = `${node.discount_percent}% ${t('campaign.virtual-sku-editor.discount')}`
  }

  if (node.use_event_item) {
    return getContextItemText(context.campaign.type as CampaignEventType)
  }

  let item = items.find(it => it.id == node.item_id)
  if (item && item.archived_at) {
    return (
      <>
        <Badge variant="red-secondary">{t('archived')}</Badge>
      </>
    )
  }

  if (item) {
    return (
      <>
        {item.name} {benefits} <Badge variant="gray-secondary">{item.sku}</Badge>
      </>
    )
  }
  return benefits
}
